import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { first } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerAccountType } from '../models/enums/customer-account-type.enum';
import { CustomerAccountService } from './service/customer-account.service';

export class AccountCreationContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    templateUrl: './customer-account-creation-modal.html'
})
export class AccountCreationModalComponent extends BaseComponent {
    accountCreationForm: UntypedFormGroup;
    selectableAccountTypes: any[];
    showButtonLoading = false;

    constructor(public location: PlatformLocation, public fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<AccountCreationModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: AccountCreationContext,
        private _customerAccountService: CustomerAccountService) {
        super();

        this.selectableAccountTypes = new CustomerAccountType().GetActive();

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    async ngOnInit() {
        this.accountCreationForm = this.fb.group({
            'accountType': ['', Validators.required],
            'accountName': [''],
            'AccountDescription': ['']
        });

        var accounts = await this._customerAccountService.getCustomerAccounts(this.data.customerNumberId).pipe(first()).toPromise();

        var primaryAccounts = accounts.result.filter(x => x.accountTypeId = 1);

        if (primaryAccounts && primaryAccounts.length > 0) {
            this.selectableAccountTypes = this.selectableAccountTypes.filter(x => x.id != 1);
        }
    }

    public cancel() {
        this.dialogRef.close();
    }

    public async save() {
        this.showButtonLoading = true;

        try {
            const result = await this._customerAccountService.saveAccount({
                customerNumberId: this.data.customerNumberId,
                customerAccountTypeId: this.accountCreationForm.controls['accountType'].value,
                customerAccountName: this.accountCreationForm.controls['accountName'].value,
                customerAccountDescription: this.accountCreationForm.controls['AccountDescription'].value
            }).pipe(first()).toPromise();
            this.showButtonLoading = false;
            this.dialogRef.close(result);
        } catch (err) {
            this.showButtonLoading = false;

            if (err.validationResults) {
                this.handleValidationResult(err);
            } else {
                throw err;
            }
        }
    }

    public accountTypeChange(event: any) {
        this.accountCreationForm.get('accountType').setValue(event);
    }
}
